import { Button } from '@zep-us/zus';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { cn } from '@/utils';
export const LoginContentGuardGradient = () => {
  return <div className="absolute inset-0 z-10 flex flex-col" data-sentry-component="LoginContentGuardGradient" data-sentry-source-file="LoginContentGuard.tsx">
      <div className="h-[400px] shrink-0 mobile-lg:h-[500px]" />
      <div className="h-[200px] shrink-0 bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,#ffffff_100%)] shadow-[2px_0_0_0_white,_-2px_0_0_0_white] mobile-lg:h-[300px]" />
      <div className="h-sm shrink-0 bg-white" />
    </div>;
};
export const LoginContentGuardDescription = ({
  quizCount,
  eventName = 'quiz_detail_login_click',
  eventProperties
}: {
  quizCount: number;
  eventName?: string;
  eventProperties?: Record<string, unknown>;
}) => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('flex shrink-0 flex-col items-center justify-center bg-white outline outline-white', 'pb-2xl pt-lg', 'mobile-lg:mb-3xl mobile-lg:pb-lg')} data-sentry-component="LoginContentGuardDescription" data-sentry-source-file="LoginContentGuard.tsx">
      <span className={cn('mb-md text-center text-heading-lg-extrabold', 'mobile-lg:text-heading-xl-extrabold')}>
        {t('common:login.guard.title', {
        n: quizCount
      })}
      </span>
      <div className={cn('mb-xl flex flex-col items-center gap-3xs text-center text-body-md-bold text-alternative', 'mobile-lg:text-heading-sm-bold')}>
        <span>
          <Trans i18nKey="common:login.guard.description1" components={{
          strong: <span className="text-primary" />
        }} data-sentry-element="Trans" data-sentry-source-file="LoginContentGuard.tsx" />
        </span>
        <span>{t('common:login.guard.description2')}</span>
      </div>
      <Button size="lg" className="min-w-[200px]" onClick={() => {
      logger.track(eventName, eventProperties);
      void router.push(`/login?callbackUrl=${encodeURIComponent(router.asPath)}`);
    }} data-sentry-element="Button" data-sentry-source-file="LoginContentGuard.tsx">
        {t('common:login.guard.button')}
      </Button>
    </div>;
};